export const matchesEmailFilter = (
  internalRequest: boolean,
  emailFilter: string,
  email?: string
): boolean => {
  if (!internalRequest && email?.toLowerCase().endsWith('@qualisflow.com')) {
    return false
  }

  return email?.toLowerCase().includes(emailFilter.toLowerCase()) ?? false
}
